import { useCallback } from "react";
import { Button, type ButtonPropsType } from "@core/components/ui/Button";
import { useUiStore } from "@core/stores/uiStore";
import { setCookie } from "@core/utils/cookieUtil";
import { getJoinUrl } from "@core/utils/urlUtil";

export default function JoinLink({ className, variant, size }: { className?: string; variant: ButtonPropsType["variant"]; size: ButtonPropsType["size"] }) {
  const network = useUiStore((state) => state.network);
  const url = getJoinUrl(network);

  const clickHandler = useCallback(() => {
    // 쿠키에 plaync로 로그인헸었다는 값 저장
    setCookie({ key: "isPlayncLogin", value: "true", path: "/" });

    // 회원가입 페이지로 이동
    window.location.href = url;
  }, [url]);

  return (
    <Button {...{ className, variant, size }} asChild={true} onClick={clickHandler}>
      <a href={url}>회원가입</a>
    </Button>
  );
}
